export default function PageScorecard() {
	return <div>{`PAGESCORECARD IS UNDER CONSTRUCTION`}</div>;
}
